import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78" {...props}>
      <defs>
        <clipPath id="clip-path">
          <path
            fill={props.fillPrimary}
            stroke="#707070"
            strokeWidth="1"
            d="M0 0H43V32H0z"
            data-name="Rectangle 992"
            transform="translate(.106 .332)"></path>
        </clipPath>
        <clipPath id="clip-AR">
          <path d="M0 0H78V78H0z"></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-AR)">
        <g data-name="Group 2749" transform="translate(17.893 14.668)">
          <g data-name="Group 2747">
            <g data-name="Group 2484">
              <g clipPath="url(#clip-path)" data-name="Mask Group 31">
                <g
                  fill={props.fillPrimary}
                  data-name="Group 2742"
                  transform="translate(4.418 -4.346)">
                  <circle
                    cx="4.46"
                    cy="4.46"
                    r="4.46"
                    data-name="Ellipse 469"
                    transform="translate(12.558 9.762)"></circle>
                  <path
                    d="M315.929 675.535l7.365 4.574s1.647 3.019 1.647 4.391a2.422 2.422 0 01-2.333 2.425c-1.327.137-13.723.915-13.723.915s-2.2-.412-1.921-2.379 2.47-2.013 2.47-2.013l9.332-.915z"
                    data-name="Path 5673"
                    transform="translate(-306.939 -641.117)"></path>
                  <path
                    d="M351.928 522.7l3.369 4.9 9.744 1.578a1.572 1.572 0 011.372 1.6 1.47 1.47 0 01-1.532 1.624c-.389-.023-11.207-1.647-11.207-1.647l-2.241-2.859-2.379 8.554s5.9 3.877 6.279 4.186a8.919 8.919 0 011.269 2.813c.172.72 4.254 12.008 4.254 12.008s1.029 2.848-1.132 3.5-2.848-.721-3.534-2.127-4.563-12.42-4.563-12.42l-12.763-7.96s-.858-.446-.378-2.642 3.088-12.42 3.088-12.42l-2.664-6.121a2.019 2.019 0 01.4-2.456c1.167-1.269 7.342-7.856 7.342-7.856s1.3-1.578 2.539-.412-.858 3.088-.858 3.088l-6.141 6.725 1.818 4.632s.812 6.559 7.918 3.712z"
                    data-name="Path 5674"
                    transform="translate(-332.036 -504.114)"></path>
                </g>
              </g>
            </g>
            <g data-name="Group 2743" transform="translate(0 34.273)">
              <rect
                width="43"
                height="16"
                fill={props.fillPrimary}
                data-name="Rectangle 918"
                rx="8"
                transform="translate(.106 .059)"></rect>
              <text
                fill={props.fillSecondary}
                fontFamily="ProximaNova-Bold, Proxima Nova"
                fontSize="15"
                fontWeight="700"
                transform="translate(22.106 13.059)">
                <tspan x="-12.855" y="0">
                  ALL
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
